import authSlice from './authSlice'

export default authSlice;